import { useClerk } from '@clerk/clerk-react';
import { IS_DEV_AUTH } from './useDevAuth';

function useClerkSignOut(): () => void {
  const { signOut } = useClerk();
  return () => signOut();
}

function useDevSignOut(): () => void {
  return () => window.location.reload();
}

export const useSignOut = IS_DEV_AUTH ? useDevSignOut : useClerkSignOut;
